// extracted by mini-css-extract-plugin
export default {"wrap":"TablePlaceholder_wrap__mjUgF","image":"TablePlaceholder_image__RA5Zj","message":"TablePlaceholder_message__tpxVK","description":"TablePlaceholder_description__rrgGn"};